/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vpn_Base_NameInputs */

const en_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const id_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const ms_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const ca_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const cs_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const da_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const de_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const et_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const es_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const fr_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const hr_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const it_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const lv_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const lt_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const hu_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const nl_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const nb_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const pl_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const pt_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const ro_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const sk_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const sl_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const fi_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const sv_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const vi_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const tr_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const el_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const bg_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const ru_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const sr_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const uk_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const ka_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const hi_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const th_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const ko_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const zh_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const zh_tw_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

const ja_vpn_base_name = /** @type {(inputs: Vpn_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN`)
};

/**
* | output |
* | --- |
* | "VPN" |
*
* @param {Vpn_Base_NameInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const vpn_base_name = /** @type {((inputs?: Vpn_Base_NameInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vpn_Base_NameInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_vpn_base_name(inputs)
	if (locale === "ms") return ms_vpn_base_name(inputs)
	if (locale === "ca") return ca_vpn_base_name(inputs)
	if (locale === "cs") return cs_vpn_base_name(inputs)
	if (locale === "da") return da_vpn_base_name(inputs)
	if (locale === "de") return de_vpn_base_name(inputs)
	if (locale === "et") return et_vpn_base_name(inputs)
	if (locale === "es") return es_vpn_base_name(inputs)
	if (locale === "fr") return fr_vpn_base_name(inputs)
	if (locale === "hr") return hr_vpn_base_name(inputs)
	if (locale === "it") return it_vpn_base_name(inputs)
	if (locale === "lv") return lv_vpn_base_name(inputs)
	if (locale === "lt") return lt_vpn_base_name(inputs)
	if (locale === "hu") return hu_vpn_base_name(inputs)
	if (locale === "nl") return nl_vpn_base_name(inputs)
	if (locale === "nb") return nb_vpn_base_name(inputs)
	if (locale === "pl") return pl_vpn_base_name(inputs)
	if (locale === "pt") return pt_vpn_base_name(inputs)
	if (locale === "ro") return ro_vpn_base_name(inputs)
	if (locale === "sk") return sk_vpn_base_name(inputs)
	if (locale === "sl") return sl_vpn_base_name(inputs)
	if (locale === "fi") return fi_vpn_base_name(inputs)
	if (locale === "sv") return sv_vpn_base_name(inputs)
	if (locale === "vi") return vi_vpn_base_name(inputs)
	if (locale === "tr") return tr_vpn_base_name(inputs)
	if (locale === "el") return el_vpn_base_name(inputs)
	if (locale === "bg") return bg_vpn_base_name(inputs)
	if (locale === "ru") return ru_vpn_base_name(inputs)
	if (locale === "sr") return sr_vpn_base_name(inputs)
	if (locale === "uk") return uk_vpn_base_name(inputs)
	if (locale === "ka") return ka_vpn_base_name(inputs)
	if (locale === "hi") return hi_vpn_base_name(inputs)
	if (locale === "th") return th_vpn_base_name(inputs)
	if (locale === "ko") return ko_vpn_base_name(inputs)
	if (locale === "zh") return zh_vpn_base_name(inputs)
	if (locale === "zh-tw") return zh_tw_vpn_base_name(inputs)
	if (locale === "ja") return ja_vpn_base_name(inputs)
	return en_vpn_base_name(inputs)
});